/**
 * Profile Security forms (Password, Delete Account)
 */
export const initSecurity = (config) => {
    const pwdForm = document.getElementById('profile-change-password-form');
    if (pwdForm) {
        const step1 = document.getElementById('ua-pwd-step-1');
        const step2 = document.getElementById('ua-pwd-step-2');
        const requestCodeBtn = document.getElementById('ua-request-pwd-code');
        const requestNewCodeBtn = document.getElementById('ua-request-new-pwd-code');
        const backBtn = document.getElementById('ua-pwd-back');
        const feedback = pwdForm.querySelector('.form-feedback');
        const initialRequestText = requestCodeBtn?.querySelector('span')?.textContent || '';
        const initialRequestNewText = requestNewCodeBtn?.querySelector('span')?.textContent || '';
        const initialSubmitText = pwdForm.querySelector('button[type="submit"] span')?.textContent || '';
        let resendTimerId = null;

        const showFeedback = (message, type = 'info') => {
            if (!feedback) return;

            feedback.textContent = message;
            feedback.className = `form-feedback form-feedback--${type} is-visible mt-3`;
        };

        const clearFeedback = () => {
            if (!feedback) return;

            feedback.textContent = '';
            feedback.className = 'form-feedback mt-3';
        };

        const setButtonLoading = (button, isLoading, loadingText, defaultText) => {
            if (!button) return;

            const label = button.querySelector('span');
            button.disabled = isLoading;
            button.classList.toggle('is-loading', isLoading);

            if (label) {
                label.textContent = isLoading ? loadingText : defaultText;
            }
        };

        const startResendTimer = () => {
            if (!requestNewCodeBtn) return;

            window.clearInterval(resendTimerId);

            let secondsLeft = 60;
            const label = requestNewCodeBtn.querySelector('span');

            requestNewCodeBtn.disabled = true;
            if (label) {
                label.textContent = `${initialRequestNewText} (${secondsLeft})`;
            }

            resendTimerId = window.setInterval(() => {
                secondsLeft -= 1;

                if (secondsLeft <= 0) {
                    window.clearInterval(resendTimerId);
                    requestNewCodeBtn.disabled = false;
                    if (label) {
                        label.textContent = initialRequestNewText;
                    }
                    return;
                }

                if (label) {
                    label.textContent = `${initialRequestNewText} (${secondsLeft})`;
                }
            }, 1000);
        };

        const requestPasswordCode = async () => {
            const contactInfo = pwdForm.querySelector('#ua_pwd_contact')?.value.trim();

            if (!contactInfo) {
                showFeedback('Вкажіть телефон або email для зв’язку.', 'error');
                return;
            }

            const formData = new FormData();
            formData.append('action', 'united_auth_request_password_change_code');
            formData.append('security', config.nonce);
            formData.append('contact_info', contactInfo);

            clearFeedback();
            setButtonLoading(requestCodeBtn, true, 'Надсилаємо запит...', initialRequestText);
            if (requestNewCodeBtn) {
                requestNewCodeBtn.disabled = true;
            }
            showFeedback('Надсилаємо запит адміністратору. Зачекайте кілька секунд...', 'info');

            try {
                const response = await fetch(config.ajax_url, { method: 'POST', body: formData });
                const result = await response.json();

                if (result.success) {
                    if (step1) step1.hidden = true;
                    if (step2) step2.hidden = false;
                    showFeedback(result.data?.message || 'Запит надіслано адміністратору. Введіть код після отримання.', 'success');
                    startResendTimer();
                    return;
                }

                showFeedback(result.data?.message || 'Не вдалося надіслати запит. Спробуйте ще раз.', 'error');
                if (requestNewCodeBtn) {
                    requestNewCodeBtn.disabled = false;
                }
            } catch (err) {
                console.error('Request code failed:', err);
                showFeedback('Не вдалося надіслати запит. Перевірте з’єднання і спробуйте ще раз.', 'error');
                if (requestNewCodeBtn) {
                    requestNewCodeBtn.disabled = false;
                }
            } finally {
                setButtonLoading(requestCodeBtn, false, 'Надсилаємо запит...', initialRequestText);
            }
        };

        if (requestCodeBtn) {
            requestCodeBtn.addEventListener('click', requestPasswordCode);
        }

        if (requestNewCodeBtn) {
            requestNewCodeBtn.addEventListener('click', requestPasswordCode);
        }

        if (backBtn) {
            backBtn.addEventListener('click', () => {
                if (step2) step2.hidden = true;
                if (step1) step1.hidden = false;
                window.clearInterval(resendTimerId);
                if (requestNewCodeBtn) {
                    requestNewCodeBtn.disabled = true;
                    const label = requestNewCodeBtn.querySelector('span');
                    if (label) {
                        label.textContent = initialRequestNewText;
                    }
                }
                clearFeedback();
            });
        }

        pwdForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const formData = new FormData(pwdForm);
            formData.append('action', 'united_auth_change_password');
            formData.append('security', config.nonce);
            const submitBtn = pwdForm.querySelector('button[type="submit"]');

            try {
                clearFeedback();
                setButtonLoading(submitBtn, true, 'Оновлюємо пароль...', initialSubmitText);
                showFeedback('Перевіряємо код і оновлюємо пароль...', 'info');

                const response = await fetch(config.ajax_url, { method: 'POST', body: formData });
                const result = await response.json();
                if (result.success) {
                    showFeedback(result.data?.message || 'Пароль оновлено.', 'success');
                    window.clearInterval(resendTimerId);
                    setTimeout(() => {
                        location.reload();
                    }, 1000);
                    return;
                }

                showFeedback(result.data?.message || 'Не вдалося оновити пароль. Перевірте код і спробуйте ще раз.', 'error');
            } catch (err) {
                console.error('Update password failed:', err);
                showFeedback('Не вдалося оновити пароль. Перевірте з’єднання і спробуйте ще раз.', 'error');
            } finally {
                setButtonLoading(submitBtn, false, 'Оновлюємо пароль...', initialSubmitText);
            }
        });
    }

    const deleteForm = document.getElementById('profile-delete-account-form');
    if (deleteForm) {
        deleteForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (!confirm(config.i18n.prof_confirm_delete_account || 'Ви справді хочете подати запит на видалення акаунта?')) return;
            const formData = new FormData(deleteForm);
            formData.append('action', 'united_auth_delete_account_request');
            formData.append('security', config.nonce);
            try {
                const response = await fetch(config.ajax_url, { method: 'POST', body: formData });
                const res = await response.json();
                if (res.success) alert(res.data.message);
            } catch (err) {
                console.error('Delete request failed:', err);
            }
        });
    }

    // Google Account Linking / Unlinking
    const googleLinkContainer = document.getElementById('ua-google-link-btn');
    const googleUnlinkBtn = document.getElementById('ua-google-unlink-btn');
    const googleFeedback = document.getElementById('ua-google-profile-feedback');
    const googleConnectedCard = document.getElementById('ua-google-profile-connected');
    const googleUnconnectedCard = document.getElementById('ua-google-profile-unconnected');
    const googleLinkedEmail = document.getElementById('ua-google-linked-email');

    const showGoogleFeedback = (msg, type = 'info') => {
        if (!googleFeedback) return;
        googleFeedback.textContent = msg;
        googleFeedback.className = `form-feedback form-feedback--${type} is-visible mt-3`;
        if (type === 'success') {
            setTimeout(() => {
                googleFeedback.classList.remove('is-visible');
            }, 5000);
        }
    };

    const clearGoogleFeedback = () => {
        if (!googleFeedback) return;
        googleFeedback.textContent = '';
        googleFeedback.className = 'form-feedback mt-3';
    };

    if (config?.google_enabled && config?.google_client_id) {
        const renderGoogleProfileBtn = () => {
            if (!window.google?.accounts?.id || !googleLinkContainer) return;
            try {
                window.google.accounts.id.initialize({
                    client_id: config.google_client_id,
                    callback: async (response) => {
                        if (!response?.credential) return;
                        clearGoogleFeedback();
                        showGoogleFeedback(config.i18n?.loading || 'Завантаження...', 'info');

                        const formData = new URLSearchParams();
                        formData.append('action', 'united_auth_google_link');
                        formData.append('security', config.nonce);
                        formData.append('id_token', response.credential);

                        try {
                            const res = await fetch(config.ajax_url, {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                body: formData.toString()
                            });
                            const data = await res.json();
                            if (data.success) {
                                showGoogleFeedback(data.data?.message || config.i18n?.google_linked_success || 'Google account linked successfully!', 'success');
                                if (googleConnectedCard && googleUnconnectedCard) {
                                    if (googleLinkedEmail && data.data?.email) {
                                        googleLinkedEmail.textContent = data.data.email;
                                    }
                                    googleConnectedCard.style.display = '';
                                    googleUnconnectedCard.style.display = 'none';
                                }
                            } else {
                                showGoogleFeedback(data.data?.message || config.i18n?.error_generic || 'Error linking Google account.', 'error');
                            }
                        } catch (e) {
                            showGoogleFeedback(config.i18n?.error_generic || 'Error linking Google account.', 'error');
                        }
                    },
                    auto_select: false
                });

                window.google.accounts.id.renderButton(googleLinkContainer, {
                    theme: 'outline',
                    size: 'large',
                    type: 'standard',
                    text: 'continue_with',
                    shape: 'rectangular',
                    logo_alignment: 'left',
                    width: googleLinkContainer.offsetWidth || 280
                });
            } catch (err) {
                console.error('Google link button initialization failed:', err);
            }
        };

        if (window.google?.accounts?.id) {
            renderGoogleProfileBtn();
        } else {
            let retries = 0;
            const interval = setInterval(() => {
                retries++;
                if (window.google?.accounts?.id) {
                    clearInterval(interval);
                    renderGoogleProfileBtn();
                } else if (retries > 50) {
                    clearInterval(interval);
                }
            }, 100);
        }
    }

    if (googleUnlinkBtn) {
        googleUnlinkBtn.addEventListener('click', async () => {
            const confirmMsg = config.i18n?.google_unlink_confirm || 'Ви впевнені, що бажаєте від\'єднати Google акаунт?';
            if (!confirm(confirmMsg)) return;

            clearGoogleFeedback();
            googleUnlinkBtn.disabled = true;

            const formData = new URLSearchParams();
            formData.append('action', 'united_auth_google_unlink');
            formData.append('security', config.nonce);

            try {
                const res = await fetch(config.ajax_url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: formData.toString()
                });
                const data = await res.json();
                if (data.success) {
                    showGoogleFeedback(data.data?.message || config.i18n?.google_unlinked_success || 'Google account disconnected.', 'success');
                    if (googleConnectedCard && googleUnconnectedCard) {
                        googleConnectedCard.style.display = 'none';
                        googleUnconnectedCard.style.display = '';

                        if (window.google?.accounts?.id && googleLinkContainer) {
                            window.google.accounts.id.renderButton(googleLinkContainer, {
                                theme: 'outline',
                                size: 'large',
                                type: 'standard',
                                text: 'continue_with',
                                shape: 'rectangular',
                                logo_alignment: 'left',
                                width: googleLinkContainer.offsetWidth || 280
                            });
                        }
                    }
                } else {
                    showGoogleFeedback(data.data?.message || config.i18n?.error_generic || 'Error unlinking Google account.', 'error');
                }
            } catch (e) {
                showGoogleFeedback(config.i18n?.error_generic || 'Error unlinking Google account.', 'error');
            } finally {
                googleUnlinkBtn.disabled = false;
            }
        });
    }

};
